export default __webpack_public_path__ + "static/media/Tricard.ca0e3d55.svg";